import { Component, ViewChild, ViewContainerRef } from '@angular/core';

import { ICellEditorAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellEditorParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'agCheckbox',
  templateUrl: './agCheckbox.component.html',
})
export class CheckboxEditor implements ICellEditorAngularComp {

  public params: ICellEditorParams;

  agInit(params: ICellEditorParams): void {
    this.params = params;
  }

  getValue() {
    return this.params.value;
  }


  checkedHandler(param: any) {
    this.params.value = param.currentTarget.checked ? '1' : '0';
    this.params.api?.stopEditing();
  }

  refresh(params:any): boolean {
    this.params.value = params.value;
    return true;
  }

 
}
